
<template>
    <div class="title">
        <div v-for="(item, index) in list" :key="index" class="left">
            <div>
                {{ item.name }}
                <i>{{ item.englishName }}</i>
            </div>
            <div v-if="item.status == 1" class="right">
                <!-- <span class="button-box" :class="status == 0 ? 'active':''" @click="selectType(0)">全部</span> -->
                <!-- <span class="button-box" :class="status == 1 ? 'active':''" @click="selectType(1)">最新动态</span> -->
                <!-- <span class="button-box" :class="status == 2 ? 'active':''" @click="selectType(2)">CMCA动态</span> -->
            </div>
            <div class="right-icon" @click="select(item.status)">
                more>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Title',
    props: {
        bol: Boolean,
        list: Array
    },
    data() {
        return {
            state: true,
            status: 0
        }
    },
    mounted() {

    },
    beforeCreate() {
        document.querySelector('body').setAttribute(
            'style',
            'margin: 0 auto; width: 100%; background:rgba(255, 255, 255, 1); overflow-x: hidden;height: 100%;')
    },
    methods: {
        selectType(index) {
            this.$emit('selectType', index)
            this.status = index
        },
        select(index) {
            if (index == 1) {
                this.$router.push({path: '/Policies/1'})
            } else if (index == 2) {
                this.$router.push({path: '/Policies/3'})
            } else if (index == 3) {
                this.$router.push({path: '/Policies/4'})
            } else if (index == 4) {
                this.$router.push({path: '/Policies/5'})
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.title {
    display: flex;
    justify-content: space-between;
    -moz-user-select: none; /* 火狐 */
    -webkit-user-select: none; /* webkit浏览器 */
    -ms-user-select: none; /* IE10 */
    -khtml-user-select: none; /* 早期浏览器 */
    .left {
        width: 100%;
        font-size: 25px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 80px;
        display: flex;
        justify-content: space-between;
        i {
            font-style: normal;
            font-size: 18px;
            font-weight: 300;
            color: rgba(153, 153, 153, 1);
            line-height: 90px;
        }
    }
    .right {
        display: flex;
        justify-content: space-around;
        align-items: center;
        cursor: pointer;
        margin-left: 380px;
        .button-box {
            height: 31px;
            display: block;
            color: rgba(102, 102, 102, 1);
            font-size: 14px;
            font-weight: 300;
            line-height: 31px;
            padding: 4px 20px;
            margin-left: 40px;
        }
        .active {
            background: rgba(36, 61, 179, 1);
            color: rgba(254, 254, 254, 1);
        }
    }
    .right-icon {
        font-size: 14px;
        font-weight: 400;
        color: rgba(37, 60, 176, 1);
        line-height: 90px;
        cursor: pointer;
    }
}
</style>
